import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ThemeProvider } from '@mui/material/styles';
import theme from './theme';
import CssBaseline from '@mui/material/CssBaseline';
import { BrowserRouter } from 'react-router-dom';
import * as Sentry from '@sentry/react';
import { initializeSentry } from './sentryConfig';

initializeSentry();
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ThemeProvider theme={theme}>
    <CssBaseline />
    <BrowserRouter>
      {/* Catches unhandled React render crashes and reports to Sentry */}
      <Sentry.ErrorBoundary
        fallback={<p>Something went wrong. Please refresh the page.</p>}
      >
        <App />
      </Sentry.ErrorBoundary>
    </BrowserRouter>
  </ThemeProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
